export default "__VITE_ASSET__DjDba5ao__"